const skills = [
  { icon: 'ri-search-eye-line', title: 'Подготовка к переговорам', desc: 'Определение цели, интересов сторон, ограничений, возможных сценариев и желаемого результата до начала разговора.' },
  { icon: 'ri-focus-2-line', title: 'Формулирование позиции', desc: 'Как ясно обозначать требования, ожидания и границы, чтобы собеседник точно понимал, чего хочет руководитель.' },
  { icon: 'ri-compass-3-line', title: 'Выявление интересов', desc: 'Понимание того, что действительно стоит за позицией сотрудника или коллеги, а не только заявленными словами.' },
  { icon: 'ri-scales-2-line', title: 'Аргументация', desc: 'Как объяснять необходимость решения через факты, цели бизнеса и интересы сторон, а не через давление.' },
  { icon: 'ri-shield-check-line', title: 'Работа с возражениями', desc: 'Как реагировать на сопротивление, не переходя сразу к давлению, и разбирать суть возражения.' },
  { icon: 'ri-star-line', title: 'Влияние', desc: 'Как добиваться принятия решений без постоянной ссылки на должность — через доверие, аргументы и авторитет.' },
  { icon: 'ri-anchor-line', title: 'Удержание позиции', desc: 'Как не отказываться от важных требований под эмоциональным или психологическим давлением.' },
  { icon: 'ri-file-check-line', title: 'Договорённости', desc: 'Как переводить разговор в конкретные обязательства, сроки и критерии результата, а не общие обещания.' },
  { icon: 'ri-check-double-line', title: 'Завершение переговоров', desc: 'Как убедиться, что стороны одинаково понимают достигнутые договорённости и что будет дальше.' },
];

export default function NegotiationSkills() {
  return (
    <section id="skills" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Чему учатся руководители
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Практические навыки управленческих переговоров, которые руководитель применяет в реальной работе
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {skills.map((s) => (
            <div key={s.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${s.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}